import React from 'react'
import { useState } from 'react';

function Pagination({postsPerPage, totalPosts , paginate, currentPage }) {

    const pageNumbers = [];
    for (let i = 1; i <= Math.ceil(totalPosts / postsPerPage); i++){
        pageNumbers.push(i)
    }


  return (
    <nav>

            <div >
                {/* <button onClick={handleNext}>next</button> */}
                {pageNumbers.map(number => (
                        <div className="pagination">
                        <a onClick={()=> paginate(number)} className={currentPage === number ? "active" : ""}>
                        {number}
                        </a>
                      </div>
                ))}
            
            </div>
        </nav>
  )
}

export default Pagination